import { stagingBannerEnabled } from '../shared/env';

/** Persistent on every authenticated page, per docs/staging-overview.md — env-driven
 * (VITE_STAGING_BANNER) rather than a permanent hard-coded fixture, so a real future production build of
 * this same shell doesn't ship it by accident. */
export function StagingBanner() {
  if (!stagingBannerEnabled) {
    return null;
  }

  return (
    <div className="staging-banner" role="status">
      EPN STAGING — SYNTHETIC DEMONSTRATION DATA ONLY — DO NOT PROCESS PAYROLL
    </div>
  );
}
